import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  commonPadding: {
    paddingHorizontal: 24,
    paddingVertical: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 4,
    paddingTop: 8,
  },
  inputStyle: {
    backgroundColor: colors['color-text-white'],
    borderColor: colors['color-gray-100'],
  },
});

interface EmailDrawerHeaderProps {
  closeDrawer: () => void,
  placeHolder?: string,
}

const EmailDrawerHeader:React.FC<EmailDrawerHeaderProps> = ({
  closeDrawer,
}) => {
  return (
    <DNABox style={[styles.commonPadding, styles.header]}>
      <DNABox appearance="row" fill alignY="center" spacing="between">

        <DNAText
          bold
          h5
          style={{
            color: colors['color-gray-600'],
          }}
        >Email Template</DNAText>
        <DNAButton
          appearance="ghost"
          status="tertiary"
          size="lg"
          iconLeft="x"
          onPress={closeDrawer}
        />
      </DNABox>
    </DNABox>
  );
};

EmailDrawerHeader.displayName = 'EmailDrawerHeader';

export default EmailDrawerHeader;
